import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import { map } from 'lodash-es';
import { Button } from '@material-ui/core';
import { differenceInMonths, isBefore, parse } from 'date-fns';

import DatePicker from '../../Components/DatePicker';
import Radio from '../../Components/Radio';

const PeriodDates = ({ initialValues, fields, onSubmit, strings, dateFormat }) => {
  const validate = values => {
    const err = {};
    const startDate = parse(values.startDate, dateFormat, new Date());
    const endDate = parse(values.endDate, dateFormat, new Date());

    if (!isBefore(startDate, endDate)) {
      err.submit = strings['error.validation.startBeforeEnd'];

      return err;
    }

    if (differenceInMonths(endDate, startDate) > 11) {
      err.submit = strings['error.validation.periodLonger'];

      return err;
    }

    return err;
  };

  return (
    <div className="form-block period-dates">
      <Formik initialValues={initialValues} onSubmit={onSubmit} validate={validate}>
        {({ errors, touched }) => (
          <>
            <Form className="formik-form">
              <div className="fields-block">
                {map(fields, (field, idx) => {
                  switch (field.type) {
                    case 'date':
                      return (
                        <div className="meta-field datepicker" key={`date_${idx}`}>
                          <div className="mdl-datefield">
                            <DatePicker
                              key={`datefield_${idx}`}
                              id={`${field.name}_${idx}`}
                              name={field.name}
                              label={strings[field.label] ?? field.label}
                              dateFormat={dateFormat}
                              touched={touched}
                              errors={errors}
                            />
                          </div>
                        </div>
                      );
                    case 'radio':
                      return (
                        <div className="meta-field selection" key={`radio_${idx}`}>
                          <div className="mdl-radiofield">
                            <Radio
                              key={`radiofield_${idx}`}
                              id={`${field.name}_${idx}`}
                              name={field.name}
                              label={strings[field.label] ?? field.label}
                              touched={touched}
                              errors={errors}
                              options={field.options}
                            />
                          </div>
                        </div>
                      );
                    default:
                      return <></>;
                  }
                })}
              </div>
              <div className="actions-block">
                <Button variant="contained" type="submit" color="primary">
                  {strings['button.label.export'] || 'Exporter'}
                </Button>
              </div>
            </Form>
            {errors.submit && <div className="error-msg">{errors.submit}</div>}
          </>
        )}
      </Formik>
    </div>
  );
};

PeriodDates.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  onSubmit: PropTypes.func,
  fields: PropTypes.array,
  initialValues: PropTypes.object,
  dateFormat: PropTypes.string,
};

PeriodDates.defaultProps = {
  strings: {},
  onSubmit: values => console.log('onSubmit::', values),
  fields: [],
  initialValues: {},
  dateFormat: 'dd/MM/yyyy',
};

export default PeriodDates;
